import { CheckCircleIcon, EnvelopeOpenIcon, ExclamationCircleIcon, NoSymbolIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { setIsDpeIdentified } from '../../../../../store/DpeReducer';
import { useAppDispatch, useAppSelector } from '../../../../../store/hook';
import { ROUTES } from '../../../../../utils/routes';

function DpeStep3() {
  const dispatch = useAppDispatch();
  const lastCompletionType = useAppSelector((state) => state.dpe.lastCompletionType);
  const selectedDpe = useAppSelector((state) => state.dpe.selectedDpe);
  const navigate = useNavigate();

  const getCompletionContent = () => {
    switch (lastCompletionType) {
      case 'noOwner':
        return {
          icon: <ExclamationCircleIcon className="h-20 w-20 text-orange-500" />,
          message: 'DPE marqué comme sans propriétaire trouvé',
        };
      case 'voluntarilyUntreated':
        return {
          icon: <NoSymbolIcon className="h-20 w-20 text-red-600" />,
          message: 'DPE marqué comme non traité volontairement',
        };
      case 'dpeGeneralMailing':
        return {
          icon: <EnvelopeOpenIcon className="h-20 w-20 text-purple-700" />,
          message: 'Envoi général préparé pour cette copropriété. Étape suivante : copier le corps du mail ou télécharger le .docx depuis l\'onglet « Envois généraux DPE » puis transmettez-le via la liste de diffusion du syndic. Aucun mail n\'a été envoyé automatiquement.',
        };
      case 'identified':
      default:
        return {
          icon: <CheckCircleIcon className="h-20 w-20 text-green-600" />,
          message: 'DPE qualifié et propriétaire(s) enregistré(s) avec succès',
        };
    }
  };

  const { icon, message } = getCompletionContent();
  const showCommunicateCta = lastCompletionType === 'dpeGeneralMailing';
  // Owners saved from the DPE land in the "Non contacté" tab; without this link users
  // stay stuck on this screen and never find where to contact them.
  const showContactOwnersCta = lastCompletionType === 'identified' || lastCompletionType === null;

  return (
    <div className="flex grow flex-col justify-center">
      <div className="mb-10 flex flex-col items-center justify-center gap-2">
        {icon}
        <p className="text-center text-lg">{message}</p>
      </div>
      <button
        type="button"
        className="mb-5 w-full rounded-xl bg-rgpd-blue-light px-3.5 py-2.5 text-lg font-semibold text-white"
        onClick={() => {
          dispatch(setIsDpeIdentified(true));
        }}
      >
        Continuer à identifier des DPEs
      </button>
      {showCommunicateCta && (
        <button
          type="button"
          className="w-full rounded-xl bg-purple-700 px-3.5 py-2.5 text-lg font-semibold text-white"
          onClick={() => {
            const coproId = selectedDpe?.idCopro;
            const search = coproId ? `?tab=envois-generaux-dpe&coproId=${coproId}` : '?tab=envois-generaux-dpe';
            navigate(`${ROUTES.PROSPECTING_COMMUNICATE}${search}`);
          }}
        >
          Préparer le mail maintenant
        </button>
      )}
      {showContactOwnersCta && (
        <button
          type="button"
          className="w-full rounded-xl bg-rgpd-green px-3.5 py-2.5 text-lg font-semibold text-white"
          onClick={() => navigate(`${ROUTES.PROSPECTING_COMMUNICATE}?tab=non-contacte`)}
        >
          Contacter le(s) propriétaire(s)
        </button>
      )}
    </div>
  );
}

export default DpeStep3;
